"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const mf_app_1 = require("@4r/mf-app");
const mf_contracts_1 = require("@4r/mf-contracts");
const displayErrorMessage = (error) => (0, mf_app_1.getService)('MessageBusService').emit(mf_contracts_1.HANDLE_ERROR_BY_HOST_EVENT, error);
/**
 *
 * @param error - error object to be parsed
 * @returns string - parsed error message
 *
 * Copied from original `handleError` method.
 */
function parseErrorMessage(error) {
    const parsed = JSON.parse(error.response);
    const errors = parsed.Errors ? parsed.Errors : parsed.errors;
    // if parsed.errors is present that means we have validation errors.
    if (errors) {
        return Object.keys(errors)
            .map((e) => { var _a; return errors[e].Message || errors[e].message || ((_a = errors[e]) === null || _a === void 0 ? void 0 : _a.join(' ')); })
            .join(' ');
    }
    const errorMessage = parsed.ErrorMessage ? parsed.ErrorMessage : parsed.errorMessage;
    try {
        const parsedErrorMessage = JSON.parse(errorMessage);
        if (Object.keys(parsedErrorMessage).every((prop) => Array.isArray(parsedErrorMessage[prop]))) {
            const parsedErrors = Object.keys(parsedErrorMessage)
                .map((prop) => parsedErrorMessage[prop].join(' '))
                .join(' ');
            return `${error.status}: ${parsedErrors}`;
        }
        const parsedErrors = Object.keys(parsedErrorMessage).map((prop) => ` ${prop}: ${typeof parsedErrorMessage[prop] === 'object' ? JSON.stringify(parsedErrorMessage[prop]) : parsedErrorMessage[prop]}`);
        return `${error.status}: ${parsedErrors}`;
    }
    catch (e) {
        return `${error.status}: ${errorMessage}`;
    }
}
function handleNonApiExceptionError(error) {
    if (error instanceof Error) {
        return `${error.name}: ${error.message}`;
    }
    if (typeof error === 'string') {
        return error;
    }
    // Offline requests: do nothing and expect the enclosing scope to catch and handle offline scenario (offline storage, etc) - 4Services PWA
    return undefined;
}
/**
 *
 * @param action - action to be called and handled
 * @param additionalErrorHandler(errorMessage: string) - if there is a need to handle error in a specific way at a component level, pass a function here - use error message
 */
function handleCommonError(action, 
/**
 * Optional error handler that intercepts the error, if returns true then the error was handled and it should not be bubbled up to the user
 */
additionalErrorHandler) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield action();
        }
        catch (error) {
            // Consume AbortError - it's expected to happen when e.g. user changes multiple filters
            if (error instanceof Error && error.name === 'AbortError') {
                return;
            }
            const errorHandled = (additionalErrorHandler === null || additionalErrorHandler === void 0 ? void 0 : additionalErrorHandler(error)) === true;
            // When the error was already handled, return
            if (errorHandled) {
                return;
            }
            if (error && typeof error === 'object' && 'response' in error && 'status' in error) {
                const apiErrorMessage = parseErrorMessage(error);
                displayErrorMessage(apiErrorMessage);
            }
            else {
                const nonApiExceptionError = handleNonApiExceptionError(error);
                if (nonApiExceptionError !== undefined) {
                    // Offline requests: do not surface offline request error to end-user, they will be handled by the outter scope
                    displayErrorMessage(nonApiExceptionError);
                }
                throw error;
            }
        }
    });
}
exports.default = handleCommonError;
